import { Outlet } from 'react-router-dom';
import { useUserStore } from '../../store/user';
import { getMe } from '../../services/api/users/user';
import { useQuery } from '@tanstack/react-query';
import {
  getApiTokensInLocalStorage,
  setUserInLocalStorage,
} from '../../services/localStorage/localStorage';
import { FullPageLoader } from '@tassomutuo-backoffice/ui';

const AppLayout = () => {
  const { setUser } = useUserStore();

  const { isLoading } = useQuery({
    queryKey: ['Me'],
    queryFn: async () => {
      const res = await getMe();
      setUser(res);
      // Mantiene localStorage allineato al profilo /me (include `ledGroups`):
      // l'utility che attacca `?hsOwnerId=` legge l'utente da localStorage.
      setUserInLocalStorage(res);
      return res;
    },
    initialData: null,
    retry: false,
    enabled: !!getApiTokensInLocalStorage(),
  });

  return (
    <div>
      <FullPageLoader show={isLoading} />
      {!isLoading && <Outlet />}
    </div>
  );
};

export default AppLayout;
